import React from "react";
import { FiX } from "react-icons/fi";
import classes from "./ViewUser.module.css";

export default function ViewUser({ open, user, onClose }) {
  if (!open || !user) return null;

  const fullName = String(user.fullName || user.name || "").trim() || "-";

  return (
    <div className={classes.overlay} onMouseDown={onClose}>
      <div className={classes.modal} onMouseDown={(e) => e.stopPropagation()}>
        <button type="button" className={classes.close} onClick={onClose}>
          <FiX />
        </button>
        <h3>User Details</h3>
        <div className={classes.grid}>
          {[
            ["ID", user.id],
            ["Full Name", fullName],
            ["Slug", user.slug],
            ["Status", user.status],
            ["Password Code", user.passwordCode],
            ["Iframe Code", user.iframeCode],
          ].map(([label, value]) => (
            <div key={label} className={classes.item}>
              <span>{label}</span>
              <p>{value || "-"}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
